var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.activities.length > 0)?_c('div',{staticClass:"row"},_vm._l((_vm.activities),function(activity){return _c('activity-card',{key:activity.id,staticClass:"col-12 col-md-6 col-xl-4 mb-4",attrs:{"activity":activity}})}),1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }